enum EventType {
  ADD_COURSE = 'addCourse',
  ADD_FORM_INPUT = 'addFormInput',
  ADD_VIDEO_PROMPT = 'addVideoPrompt',
  CAPTURED_GUEST_DATA = 'capturedGuestData',
  CHANGE_CHECKIN_INFO = 'changeCheckinInfo',
  CLICK_TO_CLEAR_VIDEO_PROMPT = 'clickToClearVideoPrompt',
  COPY_COURSE_LINK = 'copyCourseLink',
  CREATE_VALUE = 'createValue',
  DELETE_FORM_INPUT = 'deleteFormInput',
  DELETE_SECTION = 'deleteSection',
  DELETE_VALUE = 'deleteValue',
  DUPLICATE_SECTION = 'duplicateSection',
  EMAIL_FORGOT_PASSWORD = 'emailForgotPassword',
  ENTER_CLEARS_VIDEO_PROMPT = 'enterClearsVideoPrompt',
  GO_BACK_FROM_404 = 'goBackFrom404',
  GO_BACK_FROM_ERROR = 'goBackFromError',
  GO_TO_COURSE = 'goToCourse',
  GUEST_CHECKED_IN = 'guestCheckedIn',
  LOGOUT = 'logout',
  NEW_CHURCH = 'newChurch',
  NEW_SIGN_UP = 'newSignUp',
  NEXT_PROMPT = 'nextPrompt',
  PREVIOUS_PROMPT = 'previousPrompt',
  REORDER_SECTIONS = 'reorderSections',
  RESET_PASSWORD_FROM_EMAIL = 'resetPasswordFromEmail',
  SAVE_FORM_DATA_SUBMISSION = 'saveFormDataSubmission',
  SAVE_FORM_INPUT_DATA = 'saveFormInputData',
  SAVE_SECTION_DATA = 'saveSectionData',
  SAVE_TEST_SETTINGS = 'saveTestSettings',
  SAVE_VIDEO_PROMPT_DATA = 'saveVideoPromptData',
  SAVE_VIDEO_SETTINGS = 'saveVideoSettings',
  SAVE_WIDGET_DATA = 'saveWidgetData',
  SAW404 = 'saw404',
  SAW_ERROR_SCREEN = 'sawErrorScreen',
  SELECT_INPUT = 'selectInput',
  SET_PASSWORD_AFTER_INVITE = 'setPasswordAfterInvite',
  SET_SIDE_BAR_STATE_ADMIN_NAV = 'setSideBarStateAdminNav',
  SIDE_BAR_STATE_SECTION_NAV = 'sideBarStateSectionNav',
  SWITCH_CHURCHES = 'switchChurches',
  TEXTAREA_INPUT = 'textareaInput',
  TEXT_INPUT = 'textInput',
  TOGGLE_INPUT = 'toggleInput',
  TO_STRIPE_FOR_PAYMENT = 'toStripeForPayment',
  USER_LOGGED_IN = 'userLoggedIn',
}

export default EventType;
